import { render, staticRenderFns } from "./ShopsCreationUser.vue?vue&type=template&id=4b7fd41e"
import script from "./ShopsCreationUser.vue?vue&type=script&lang=js"
export * from "./ShopsCreationUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports